exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".quick-message {\r\n  position: fixed;\r\n  z-index: 9999;\r\n  top: 30px;\r\n  left: 50%;\r\n  -webkit-transform: translateX(-50%);\r\n          transform: translateX(-50%);\r\n}\r\n\r\n.quick-information {\r\n  background-color: #3e98eb;\r\n  padding: 23px;\r\n  border-radius: 3px;\r\n  color: #103c64;\r\n  box-shadow: 0px 0px 10px #222;\r\n}\r\n.quick-information .quick-icon {\r\n  display: table-cell;\r\n  vertical-align: middle;\r\n  padding-right: 15px;\r\n  font-size: 30px;\r\n  padding-left: 10px;\r\n}\r\n.quick-information .quick-text {\r\n  display: table-cell;\r\n  padding: 0 10px;\r\n  width: 270px;\r\n}\r\n.quick-information .quick-text h4 {\r\n  margin-top: 0;\r\n  margin-bottom: 5px;\r\n}\r\n.quick-information .quick-text p {\r\n  color: #103c64;\r\n}\r\n.quick-information span.ti-close {\r\n  display: table-cell;\r\n  padding-left: 10px;\r\n}\r\n\r\n.animated {\r\n  -webkit-animation-duration: 0.5s;\r\n  animation-duration: 0.5s;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Work-Local/frontend/src/app/_shared/layout/modal-info-message/modal-info-message.component.css
// module id = ../../../../../src/app/_shared/layout/modal-info-message/modal-info-message.component.css
// module chunks = main